import { render, staticRenderFns } from "./TransactionHistoryPage.vue?vue&type=template&id=7dda8746&"
import script from "./TransactionHistoryPage.vue?vue&type=script&lang=js&"
export * from "./TransactionHistoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports